import Intro from '../components/Intro';
import ChapterOne from '../components/ChapterOne';
import ChapterTwo from '../components/ChapterTwo';
import ChapterThree from '../components/ChapterThree';
import ChapterFour from '../components/ChapterFour';
import ChapterFive from '../components/ChapterFive';
import ChapterSix from '../components/ChapterSix';
import Outro from '../components/Outro';

const chapters = {
  intro:[ 
    Intro
  ],
  one:[ 
    Intro,
    ChapterOne
  ],
  two:[ 
    Intro,
    ChapterOne,
    ChapterTwo,
  ],
  three:[ 
    Intro,
    ChapterOne,
    ChapterTwo,
    ChapterThree,
  ],
  four:[ 
    Intro,
    ChapterOne,
    ChapterTwo,
    ChapterThree,
    ChapterFour,
  ],
  five:[ 
    Intro,
    ChapterOne,
    ChapterTwo,
    ChapterThree,
    ChapterFour,
    ChapterFive,
  ],
  six:[ 
    Intro,
    ChapterOne,
    ChapterTwo,
    ChapterThree,
    ChapterFour,
    ChapterFive,
    ChapterSix,
  ],
  outro:[ 
    Intro,
    ChapterOne,
    ChapterTwo,
    ChapterThree,
    ChapterFour,
    ChapterFive,
    ChapterSix,
    Outro,
  ],
}

export default chapters;
